import React from 'react'
import * as Displays from 'support/displays'
import { useValue } from '@morningtrain/react-resources'
import { useEnvValue } from '@morningtrain/react-helpers'
import WhenCleaningCheckupIsCompleted from 'pages/app/cleaning/partials/WhenCleaningCheckupIsCompleted'

export default function StepPointOption (props) {
  const {
    points = null,
    stepId,
    isCompleted = false
  } = props

  const optionPointValue = useValue('points')

  const [selectedPointForStep, setSelectedPointForStep] = useEnvValue(`cleaning.steps.${stepId}.points`, points)

  const isActive = selectedPointForStep === optionPointValue

  const imgClasses = [
    'cursor-pointer w-full h-0 relative border-2 rounded-md overflow-hidden',
    isActive ? 'border-primary-500' : 'border-gray-200'
  ].filter(x => x)

  const labelClasses = [
    'absolute bottom-0 left-0 px-3 py-1 rounded-tr-md rounded-bl-md',
    isActive ? 'bg-primary-500 text-white' : 'bg-gray-200 text-primary-900'
  ].filter(x => x)

  const onChange = (value) => {
    if (isCompleted === true) {
      return
    }
    setSelectedPointForStep(Number(value))
  }

  return (
    <label className='relative inline-block pointer' htmlFor={`steps[${stepId}][points][${optionPointValue}]`}>
      <input
        id={`steps[${stepId}][points][${optionPointValue}]`}
        type='radio'
        name={`steps[${stepId}][points]`}
        value={optionPointValue}
        defaultChecked={isActive}
        onChange={(e) => onChange(e.target.value)}
        className='w-0 h-0 opacity-0 absolute'
      />
      <div className={imgClasses.join(' ')} style={{ paddingBottom: '120%' }}>
        <div className='absolute top-0 left-0 w-full h-full'>
          <Displays.Image name='img' className='w-full h-full block object-cover' lazy />
        </div>
      </div>
      <span className={labelClasses.join(' ')}>
        <Displays.Text name='label' />
      </span>
    </label>
  )
}
